import React, { Component } from 'react';
import { deFormatTime } from 'mythil/time';
import MaskedInput from '~/components/MaskedInput/MaskedInput';
import { ReadonlyField } from '~/native-ui/Fields/ReadonlyField';
import { Center } from '~/native-ui/native-base';
import { Icon } from '~/native-ui/Icon';
import { Button } from '~/native-ui/Button';
import { TimePickerDialog } from '~/native-ui/DateTimePicker';

export class TimeField extends Component {
    static defaultProps = {
        mask: '11:11',
    };

    state = {
        active: false,
    };

    componentDidUpdate = () => {};

    componentDidMount = () => {};

    onChangeMaskInput = (value) => {
        if (value) {
            let valueClean = value.replace(/[:. _]/g, '');
            if (valueClean.length < 1) {
                value = null;
            }
        }

        return this.props.onChange(value);
    };

    onChangeCalendar = (val) => {
        this.setState({ active: false });

        if (!val) {
            return this.props.onChange(val);
        }

        val = deFormatTime(val);

        return this.props.onChange(val);
    };

    getValue = () => {
        let { value } = this.props;
        if (!value) {
            return '';
        }

        return value;
    };

    getCalendarValue = () => {
        let { value } = this.props;
        if (value instanceof Date) return value;
        else if (typeof value === 'string') {
            const time = new Date();
            const [hours = 0, minutes = 0, seconds = 0] = value.slice(-5).split(':');
            time.setHours(hours);
            time.setMinutes(minutes);
            time.setSeconds(seconds);
            return time;
        }
        return new Date();
    };

    openCalendar = () => {
        this.setState({ active: true });
    };

    closeCalendar = () => {
        this.setState({ active: false });
    };

    renderReadonly = () => {
        let { value } = this.props;

        return (
            <ReadonlyField
                className={this.props.className}
                label={this.props.title}
                value={value}
                tooltip={this.props.tooltip}
            />
        );
    };

    iconProps = { size: 'xs' };
    renderTimeButton() {
        if (this.props.disabled)
            return (
                <Center>
                    <Icon type="schedule" size="xs" />
                </Center>
            );
        return (
            <Center>
                <TimePickerDialog type="auto" value={this.getCalendarValue()} onChange={this.onChangeCalendar}>
                    <Button colorScheme="muted" icon="schedule" iconProps={this.iconProps} />
                </TimePickerDialog>
            </Center>
        );
    }

    render() {
        if (this.props.isReadonly) {
            return this.renderReadonly();
        }

        return (
            <MaskedInput
                onChange={this.onChangeMaskInput}
                isRevealingMask={true}
                floating={this.props.floating}
                ref={this.props.ref}
                onKeyPress={this.props.onKeyPress}
                style={this.props.style}
                invalid={this.props.invalid}
                error={this.props.validationMessage}
                label={this.props.title}
                tooltip={this.props.tooltip}
                required={this.props.required}
                value={this.getValue()}
                mask={this.props.mask}
                iconRight={this.renderTimeButton()}
            />
        );
    }
}
